const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
let activeLayer = null;
let savedBodyOverflow = '';

function getTarget(trigger) {
  const selector = trigger.getAttribute('data-motored-target');
  return selector ? document.querySelector(selector) : null;
}

function focusFirst(container) {
  const first = container.querySelector(focusableSelector);
  (first || container).focus();
}

function setScrollLock(locked) {
  if (locked) {
    savedBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = savedBodyOverflow;
  }
}

function closeDropdown(dropdown) {
  const trigger = dropdown.querySelector('[data-motored-toggle="dropdown"]');
  const menu = dropdown.querySelector('.dropdown-menu, .sub-menu');
  menu?.classList.remove('show');
  trigger?.setAttribute('aria-expanded', 'false');
}

function openLayer(layer, type, trigger) {
  if (activeLayer) closeLayer();

  activeLayer = { element: layer, type, trigger };
  layer.classList.add('show');
  layer.setAttribute('aria-hidden', 'false');
  layer.setAttribute('aria-modal', 'true');
  layer.setAttribute('role', 'dialog');
  if (type === 'offcanvas') trigger.setAttribute('aria-expanded', 'true');
  setScrollLock(true);

  const backdrop = document.createElement('div');
  backdrop.className = `${type}-backdrop fade show`;
  backdrop.setAttribute('aria-hidden', 'true');
  backdrop.addEventListener('click', closeLayer);
  document.body.append(backdrop);
  activeLayer.backdrop = backdrop;

  focusFirst(layer);
}

function closeLayer() {
  if (!activeLayer) return;

  const layer = activeLayer.element;
  const trigger = activeLayer.trigger;
  layer.classList.remove('show');
  layer.setAttribute('aria-hidden', 'true');
  layer.removeAttribute('aria-modal');
  if (activeLayer.type === 'offcanvas') trigger?.setAttribute('aria-expanded', 'false');
  activeLayer.backdrop?.remove();
  activeLayer = null;
  setScrollLock(false);
  trigger?.focus();
}

function activateTab(trigger) {
  const tabList = trigger.closest('[role="tablist"]');
  const target = getTarget(trigger);
  if (!tabList || !target) return;

  tabList.querySelectorAll('[data-motored-toggle="tab"]').forEach((tab) => {
    const selected = tab === trigger;
    tab.classList.toggle('active', selected);
    tab.setAttribute('aria-selected', String(selected));
    tab.tabIndex = selected ? 0 : -1;
  });

  const content = target.parentElement;
  content.querySelectorAll('.tab-pane').forEach((pane) => {
    const selected = pane === target;
    pane.classList.toggle('active', selected);
    pane.classList.toggle('show', selected);
    pane.setAttribute('aria-hidden', String(!selected));
  });
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-motored-toggle]');
  const dismiss = event.target.closest('[data-motored-dismiss]');

  if (dismiss && activeLayer) {
    event.preventDefault();
    closeLayer();
    return;
  }

  if (trigger) {
    const type = trigger.getAttribute('data-motored-toggle');

    if (type === 'dropdown') {
      event.preventDefault();
      const dropdown = trigger.closest('.dropdown, .menu-item-has-children');
      const menu = dropdown?.querySelector('.dropdown-menu, .sub-menu');
      const opening = menu && !menu.classList.contains('show');
      document.querySelectorAll('.dropdown, #mainmenu .menu-item-has-children').forEach(closeDropdown);
      if (opening) {
        menu.classList.add('show');
        trigger.setAttribute('aria-expanded', 'true');
      }
    } else if (type === 'offcanvas' || type === 'modal') {
      event.preventDefault();
      const target = getTarget(trigger);
      if (target) openLayer(target, type, trigger);
    } else if (type === 'tab') {
      event.preventDefault();
      activateTab(trigger);
    }
  }

  document.querySelectorAll('.dropdown, #mainmenu .menu-item-has-children').forEach((dropdown) => {
    if (!dropdown.contains(event.target)) closeDropdown(dropdown);
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    if (activeLayer) closeLayer();
    document.querySelectorAll('.dropdown, #mainmenu .menu-item-has-children').forEach(closeDropdown);
    return;
  }

  if (!activeLayer || event.key !== 'Tab') return;

  const focusable = [...activeLayer.element.querySelectorAll(focusableSelector)];
  if (!focusable.length) {
    event.preventDefault();
    activeLayer.element.focus();
    return;
  }

  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
});

document.addEventListener('keydown', (event) => {
  if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;

  const trigger = event.target.closest('[data-motored-toggle="dropdown"]');
  const menu = trigger?.closest('.dropdown, .menu-item-has-children')?.querySelector('.dropdown-menu, .sub-menu');
  if (!menu?.classList.contains('show')) return;

  const items = [...menu.querySelectorAll('a[href], button:not([disabled])')];
  const current = items.indexOf(document.activeElement);
  if (!items.length) return;

  event.preventDefault();
  const delta = event.key === 'ArrowDown' ? 1 : -1;
  items[(current + delta + items.length) % items.length].focus();
});